exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "#app[data-v-53097dd2]{height:100%;position:relative}", ""]);
